<template>
    <div class="personal_create_team">
        <i-row>
            <i-col span="24">
                <i-carousel autoplay loop>
                    <i-carouselItem v-for="item in slideDate">
                        <div class="carousel"><img class="carousel_img" :src="url + item.path"/></div>
                    </i-carouselItem>
                </i-carousel>
            </i-col>
        </i-row>
        <i-row class="margintop">
            <i-col span="3" offset="3" class="verticalMenu">
                <i-menu active-name="create_team" style="text-align: center;width: 100%;" @on-select="routeTo">
                    <i-menuGroup title="个人中心" style="padding-left: 0px;">
                        <i-menuItem name="create_team">
                            <i-icon type="md-document"/>
                            团队管理<br>
                        </i-menuItem>
                        <i-menuItem name="job">
                            <i-icon type="ios-ribbon"/>
                            提交作品<br>
                        </i-menuItem>
                        <i-menuItem name="audit">
                            <i-icon type="ios-people"/>
                            报名情况<br>
                        </i-menuItem>
                        <i-menuItem name="audit">
                        </i-menuItem>
                    </i-menuGroup>
                </i-menu>
            </i-col>
            <i-col span="14" offset="1">
                <i-row class="title_head">
                    创建团队
                </i-row>
                <i-row style="margin-top: 20px;">
                    <i-col span="16" offset="4">
                        <i-form ref="formTeam" :rules="ruleValidate" :model="formTeam" :label-width="120">
                            <form-item label="队伍logo(请尽量上传偏正方形图片)" prop="logo">
                                <div class="demo-upload-list" v-for="item in uploadList">
                                    <template v-if="item.status === 'finished'">
                                        <img :src="item.url">
                                        <div class="demo-upload-list-cover">
                                            <i-icon type="ios-eye-outline"
                                                    @click.native="handleView(item.name)"></i-icon>
                                            <i-icon type="ios-trash-outline"
                                                    @click.native="handleRemove(item)"></i-icon>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <Progress v-if="item.showProgress" :percent="item.percentage"
                                                  hide-info></Progress>
                                    </template>
                                </div>
                                <i-upload
                                        ref="upload"
                                        :show-upload-list="false"
                                        :default-file-list="defaultList"
                                        :on-success="handleSuccess"
                                        :format="['jpg','jpeg','png']"
                                        :max-size="2048000"
                                        :on-format-error="handleFormatError"
                                        :on-exceeded-size="handleMaxSize"
                                        :before-upload="handleBeforeUpload"
                                        :headers="{Authorization:auth}"
                                        multiple
                                        type="drag"
                                        :action="upurl"
                                        style="display: inline-block;width:58px;">
                                    <div style="width: 58px;height:58px;line-height: 58px;">
                                        <i-icon type="ios-camera" size="20"></i-icon>
                                    </div>
                                </i-upload>
                                <i-modal title="View Image" v-model="visible">
                                    <img :src="'https://o5wwk8baw.qnssl.com/' + imgName + '/large'" v-if="visible"
                                         style="width: 100%">
                                </i-modal>
                            </form-item>
                            <form-item label="选题类别" prop="topic_id">
                                <i-select v-model="formTeam.topic_id" :disabled="update">
                                    <i-option v-for="item in selectTopic" :value="item.id" :key="item.id">
                                        {{ABC[item.id]}}
                                    </i-option>
                                </i-select>
                            </form-item>
                            <form-item label="策划主题名称" prop="logoname">
                                <i-input v-model="formTeam.logoname" placeholder="请输入策划主题名称"
                                         :disabled="update"></i-input>
                            </form-item>
                            <form-item label="队名" prop="name">
                                <i-input v-model="formTeam.name" placeholder="请输入队名" :disabled="update"></i-input>
                            </form-item>
                            <form-item label="成员名" prop="name">
                                <i-input v-model="formTeam.numbername" placeholder="以逗号分隔开成员名"></i-input>
                            </form-item>
                            <form-item label="指导老师" prop="name">
                                <i-input v-model="formTeam.teacher" placeholder="请输入指导老师"></i-input>
                            </form-item>
                            <form-item label="口号" prop="slogan">
                                <i-input v-model="formTeam.slogan" placeholder="请输入口号"></i-input>
                            </form-item>
                            <form-item label="所属学校" prop="school">
                                <i-input v-model="formTeam.school" placeholder="请输入所属学校" :disabled="update"></i-input>
                            </form-item>
                            <form-item label="成员人数" prop="number">
                                <i-input v-model="formTeam.number" placeholder="请输入成员人数" :number="true"></i-input>
                            </form-item>
                            <hr/>
                            <br/>
                            <i-row>
                                <i-col span="12">
                                    <form-item label="队长姓名" prop="one_name">
                                        <i-input v-model="formTeam.one_name" placeholder="请输入队长姓名"></i-input>
                                    </form-item>
                                    <form-item label="队长邮箱" prop="one_email">
                                        <i-input v-model="formTeam.one_email" placeholder="请输入队长邮箱"></i-input>
                                    </form-item>
                                    <form-item label="队长手机" prop="one_phone">
                                        <i-input v-model="formTeam.one_phone" placeholder="请输入队长手机"></i-input>
                                    </form-item>
                                    <form-item label="队长QQ" prop="one_qq">
                                        <i-input v-model="formTeam.one_qq" placeholder="请输入队长QQ"></i-input>
                                    </form-item>
                                </i-col>
                                <i-col span="12">
                                    <form-item label="第二联系人姓名" prop="two_name">
                                        <i-input v-model="formTeam.two_name" placeholder="请输入第二联系人姓名"></i-input>
                                    </form-item>
                                    <form-item label="第二联系人邮箱" prop="two_email">
                                        <i-input v-model="formTeam.two_email" placeholder="请输入第二联系人邮箱"></i-input>
                                    </form-item>
                                    <form-item label="第二联系人手机" prop="two_phone">
                                        <i-input v-model="formTeam.two_phone" placeholder="请输入第二联系人手机"></i-input>
                                    </form-item>
                                </i-col>
                            </i-row>
                            <form-item>
                                <i-button type="primary" @click="modal1=true" size="large" :disabled="add">
                                    保存
                                </i-button>
                                <i-button @click="handleReset('formTeam')" style="margin-left: 8px" size="large">重置
                                </i-button>
                                <Modal
                                        v-model="modal1"
                                        title="提示"
                                        @on-ok="handleSubmit('formTeam')"
                                        @on-cancel="cancel">
                                    <p>选题、策划主题名称、团队名、所属学校提交后，经审核通过，不可更改！</p>
                                </Modal>
                            </form-item>
                        </i-form>
                    </i-col>
                </i-row>
            </i-col>
        </i-row>
    </div>
</template>

<script>
    import {
        Icon,
        Col,
        Row,
        Carousel,
        CarouselItem,
        Breadcrumb,
        BreadcrumbItem,
        Menu,
        MenuGroup,
        MenuItem,
        Form,
        FormItem,
        Input,
        Select,
        Option,
        Button,
        DatePicker,
        CheckboxGroup,
        Checkbox,
        Switch,
        Upload,
        Modal
    } from 'iview'
    import {api_getData} from '../../api/carousel'
    import {api_getTeam, api_save} from '../../api/personal/team'
    import {api_getClass} from '../../api/personal/topic'
    import {api_getJob} from '../../api/personal/job'
    import {url, root, auth_key, aliyun} from '../../config'

    export default {
        name: '',
        components: {
            'i-form': Form,
            'form-item': FormItem,
            'i-col': Col,
            'i-row': Row,
            'i-icon': Icon,
            'i-carousel': Carousel,
            'i-carouselItem': CarouselItem,
            'i-breadcrumb': Breadcrumb,
            'i-breadcrumbItem': BreadcrumbItem,
            'i-menu': Menu,
            'i-menuGroup': MenuGroup,
            'i-menuItem': MenuItem,
            'i-input': Input,
            'i-select': Select,
            'i-option': Option,
            'i-button': Button,
            'i-datePicker': DatePicker,
            'i-checkboxGroup': CheckboxGroup,
            'i-checkbox': Checkbox,
            'i-switch': Switch,
            'i-upload': Upload,
            'i-modal': Modal,
        },
        data() {
            return {
                modal1:false,
                ABC: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
                slideDate: [],
                url: url,
                selectTopic: [],
                aliyun: aliyun,
                details: '',
                add: false,
                update: false,
                auth: sessionStorage.getItem(auth_key),
                // ver_name : this.$route.params.ver_name,
                formTeam: {
                    name: '',
                    slogan: '',
                    school: '',
                    number: 0,
                    topic_id: '',
                    one_name: '',
                    one_email: '',
                    one_qq: '',
                    one_phone: '',
                    numbername: '',
                    teacher: '',
                    two_name: '',
                    two_phone: '',
                    two_email: '',
                    serial_number: '',
                    audit: 0,
                    logo: '',
                    logoname: ''
                },
                upurl: root + '/personal/team/upimg',
                imgName: '',
                visible: false,
                uploadList: [],
                defaultList: [
                    // {url:''}
                ],
                ruleValidate: {
                    logoname: [
                        {required: true, message: '策划主题名称', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '队名不能为空', trigger: 'blur'}
                    ],
                    numbername: [
                        {required: true, message: '队员不能为空', trigger: 'blur'}
                    ],
                    teacher: [
                        {required: true, message: '指导老师不能为空', trigger: 'blur'}
                    ],
                    logo: [
                        {required: true, message: '队伍logo不能为空', trigger: 'blur'}
                    ],
                    slogan: [
                        {required: true, message: '口号不能为空', trigger: 'blur'}
                    ],
                    school: [
                        {required: true, message: '学校不能为空', trigger: 'blur'}
                    ],
                    number: [
                        {required: true, type: 'number', message: '成员人数不能为空', trigger: 'blur'}
                    ],
                    one_name: [
                        {required: true, message: '队长不能为空', trigger: 'blur'}
                    ],
                    one_phone: [
                        {required: true, message: '队长手机不能为空', trigger: 'blur'}
                    ],
                    one_email: [
                        {required: true, message: '队长邮箱不能为空', trigger: 'blur'}
                    ],
                    topic_id: [
                        {required: true, message: '选题不能为空'}
                    ],
                },
            }
        },
        async created() {
            let _data = await api_getData('home')
            let res = _data.body
            if (res.code === 0) {
                this.slideDate = res.data
            }

        },
        mounted() {
            this.uploadList = this.$refs.upload.fileList
            api_getTeam().then(_data => {
                let res = _data.body
                if (res.code === 0) {
                    this.formTeam = res.data
                    // console.log(this.formTeam)
                    if (this.formTeam.audit === 1) {
                        this.update = true
                    }
                    this.defaultList[0].url = this.aliyun + '' + res.data.logo
                } else {
                    this.$Message.error(res.msg)
                }
            })
            api_getClass().then(_data => {
                let res = _data.body
                if (res.code === 0) {
                    this.selectTopic = res.data
                    // console.log(this.selectTopic)
                }
            })
            api_getJob().then(_data => {
                let res = _data.body
                if (res.code === 0) {
                    this.formJob = res.data
                    // console.log(this.formJob)
                } else {
                    this.$Message.error(res.msg)
                }
            })
        },
        methods: {
            handleView(name) {
                this.imgName = name
                this.visible = true
            },
            handleRemove(file) {
                const fileList = this.$refs.upload.fileList
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1)
            },
            handleSuccess(res, file) {
                if (res.code === 1) {
                    file.url = this.aliyun + '' + res.data.name
                    file.name = res.data.name
                    this.formTeam.logo = res.data.name
                } else {
                    this.$Notice.warning({
                        title: '上传失败.'
                    })
                }
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: 'The file format is incorrect',
                    desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
                })
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: 'Exceeding file size limit',
                    desc: 'File  ' + file.name + ' is too large, no more than 2M.'
                })
            },
            handleBeforeUpload() {
                const check = this.uploadList.length < 1
                if (!check) {
                    this.$Notice.warning({
                        title: '最多只能上传一张'
                    })
                }
                return check
            },

            routeTo(name) {
                this.$router.push({name: 'personal_' + name, params: {ver_name: name}})
            },
            cancel () {
                this.$Message.info('已取消');
            },
            handleSubmit(name) {



                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.modal1 = true
                        this.add = true
                        let data = this.formTeam
                        api_save(data).then(_data => {
                            let res = _data.body
                            // 保存成功
                            if (res.code === 0) {
                                this.$Message.success({
                                    content: res.msg,
                                    onClose: () => {
                                        window.location.reload()
                                        // this.$router.push({name: 'personal_create_team'});
                                    }
                                })
                            } else {
                                this.add = false
                                this.$Message.error({
                                    content: res.msg,
                                    onClose: () => {
                                        window.location.reload()
                                    }
                                })
                            }
                        })
                    } else {
                    }
                })




            },
            handleReset(name) {
                this.$refs[name].resetFields()
            }
        }
    }
</script>

<style lang="scss">
    .personal_create_team {
        text-align: left;
        /*轮播图设置*/
        .carousel {
            .carousel_img {
                width: 100%;
                height: 100%;
            }
        }

        /*row间距设置*/
        .margintop {
            margin-top: 20px;
        }

        /*菜单栏start*/
        .verticalMenu {
            .ivu-menu-vertical .ivu-menu-item-group-title {
                height: 48px;
                color: #3d2404;
                line-height: 48px;
                font-size: 18px;
                padding: 0px;
                margin-top: 10px;
                border-bottom: 2px solid #ffffff;
            }

            .ivu-menu-light {
                background: #9933cc;
            }

            .ivu-menu {
                display: block;
                border-radius: 40px;
                overflow: hidden;
                color: #ffffff;
                font-size: 14px;
                position: relative;
            }

            .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
                /*color: #ffffff;*/
                color: #000000;
                font-weight: 600;
                /*background: #cf8d0f;*/
                background: #c34ae4;
                z-index: 2;
            }

            .ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
                color: #3d2404;
            }

            .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
                content: '';
                display: block;
                width: 2px;
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                /*background: #e5ea20;*/
                background: #c34ae4;
            }
        }

        /*菜单栏end*/

        /*小标题start*/
        .title_head {
            height: 30px;
            line-height: 30px;
            background: rgb(153, 51, 204);
            border-radius: 5px;
            padding-left: 30px;
            color: white;
            font-weight: 600;
            font-size: 15px;
        }

        /*小标题end*/


        .demo-upload-list {
            display: inline-block;
            width: 60px;
            height: 60px;
            text-align: center;
            line-height: 60px;
            border: 1px solid transparent;
            border-radius: 4px;
            overflow: hidden;
            background: #fff;
            position: relative;
            box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
            margin-right: 4px;
        }

        .demo-upload-list img {
            width: 100%;
            height: 100%;
        }

        .demo-upload-list-cover {
            display: none;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, .6);
        }

        .demo-upload-list:hover .demo-upload-list-cover {
            display: block;
        }

        .demo-upload-list-cover i {
            color: #fff;
            font-size: 20px;
            cursor: pointer;
            margin: 0 2px;
        }
    }
</style>
